import { Field, useFormikContext } from 'formik'

import Autocomplete from '../../../Autocomplete'
import ToggleButton from '../../../ToggleButton'

const ClassificationsDetails = ({
  majorCategories,
  minorCategories,
  modifierGroups,
  isItemModifier,
  id,
  showValidationErrors,
}) => {
  const { values, setFieldValue } = useFormikContext()
  return (
    <div className="item-classifications" id={id}>
      <h3 className="header-title">Classifications</h3>
      <div className="content-wrapper -flags-wrapper">
        <span className="content-header">Alcohol</span>
        <span className="content-value">
          <Field
            component={ToggleButton}
            name="alcohol"
            type="checkbox"
          />
        </span>
      </div>
      <div className="content-wrapper -flags-wrapper">
        <span className="content-header">Discountable</span>
        <span className="content-value">
          <Field
            component={ToggleButton}
            name="discountable"
            type="checkbox"
          />
        </span>
      </div>
      <div className="content-wrapper -flags-wrapper">
        <span className="content-header">Auto-Advance</span>
        <span className="content-value">
          <Field
            component={ToggleButton}
            name="autoAdvance"
            type="checkbox"
          />
        </span>
      </div>
      <div className="content-wrapper -multi-select-wrapper">
        <span className="content-value">
          <Field
            handleValueChange={(value) =>
              setFieldValue('itemCategoryUuids', value)
            }
            value={values['itemCategoryUuids']}
            component={Autocomplete}
            data={minorCategories}
            isMulti={true}
            name="itemCategoryUuids"
            placeholder="Display Categories"
            type="select"
            showValidationErrors={showValidationErrors}
          />
        </span>
      </div>
      <div className="content-wrapper -multi-select-wrapper">
        <span className="content-value">
          <Field
            handleValueChange={(value) =>
              setFieldValue('reportingCategoryUuid', value[0])
            }
            value={values['reportingCategoryUuid']}
            component={Autocomplete}
            data={majorCategories}
            name="reportingCategoryUuid"
            placeholder="Reporting Categories"
            type="select"
            showValidationErrors={showValidationErrors}
          />
        </span>
      </div>
    </div>
  )
}

export default ClassificationsDetails
